import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { MenuItem, FormControl, Select } from "@mui/material";
import { getListStatus } from "../Store/Actions/ChatAction";
import { toast } from "react-toastify";

const SaveResultModal = ({
  onClose,
  CampaignID,
  AssignmentID,
  confirmEndChat,
}) => {
  const initGroup = [
    {
      ISGroupID: 0,
      GroupName: "---Please Select Group---",
    },
  ];
  const initCode = [
    {
      ISCodeID: 0,
      ISCode: "0",
      StatusName: "---Please Select Status---",
    },
  ];
  const initReason = [
    {
      ISCodeReasonID: 0,
      ReasonCode: "0",
      ReasonText: "---Please Select Reason---",
    },
  ];
  const [input1, setInput1] = useState(initGroup);
  const [input2, setInput2] = useState(initCode);
  const [input3, setInput3] = useState(initReason);
  const [group, setGroup] = useState(0);
  const [code, setCode] = useState("0");
  const [reason, setReason] = useState("0");
  const [options, setOptions] = useState("group");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const fetchDataListStatus = async (typeStatus, statusID) => {
      const response = await getListStatus(CampaignID, typeStatus, statusID);
      if (response.status) {
        if (typeStatus === "group") setInput1(response.data);
        else if (typeStatus === "code") setInput2(response.data);
        else if (typeStatus === "reason") setInput3(response.data);
      } else {
        // toast.warn(response.error);
      }
    };
    fetchDataListStatus(options, status);
  }, [CampaignID, options, status]);

  const buttonActionSaveResult = (value1, value2, value3) => {
    if (!value1) toast.warning("Please Select Group");
    else if (!value2) {
      toast.warning("Please Select Status");
    } else
      confirmEndChat(2, 0, AssignmentID, value2, value3 === 0 ? "" : value3);
  };
  const handleChange1 = (event) => {
    const status = event.target.value;
    setGroup(status);
    setCode(0);
    setInput2(initCode);
    setReason(0);
    setInput3(initReason);
    setStatus(status);
    setOptions("code");
  };
  const handleChange2 = (event) => {
    const status = event.target.value;
    setCode(status);
    setReason(0);
    setInput3(initReason);
    const id = input2.find((x) => x.ISCode === status)?.ISCodeID ?? 0;
    setStatus(id);
    setOptions("reason");
  };
  const handleChange3 = (event) => {
    setReason(event.target.value);
  };
  return (
    <div className="overlayHistory">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalSaveResult"
      >
        <CloseOutlinedIcon
          className="closeBtn"
          onClick={onClose}
        ></CloseOutlinedIcon>
        <div className="contentSaveResult">
          <h3
            style={{
              color: "gray",
              alignSelf: "center",
              marginBottom: "26px",
              fontSize: 22,
            }}
          >
            Save Result WA
          </h3>
          <div className="SaveResultModalBody">
            <div className="SaveResultForm1">
              <span>Group</span>
              <div>
                <FormControl sx={{ m: 1, width: 300 }}>
                  <Select
                    id="demo-simple-select1"
                    value={group}
                    onChange={handleChange1}
                    inputProps={{ "aria-label": "Without label" }}
                    size="small"
                  >
                    {input1.map((x) => {
                      return (
                        <MenuItem value={x.ISGroupID} key={x.ISGroupID}>
                          {x.GroupName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="SaveResultForm1">
              <span>Status</span>
              <div>
                <FormControl sx={{ m: 1, width: 300 }}>
                  <Select
                    id="demo-simple-select2"
                    value={code}
                    onChange={handleChange2}
                    inputProps={{ "aria-label": "Without label" }}
                    size="small"
                  >
                    {input2.map((x) => {
                      return (
                        <MenuItem value={x.ISCode} key={x.ISCode}>
                          {x.StatusName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </div>
            {input3.length > 1 ? (
              <div className="SaveResultForm1">
                <span>Reason</span>
                <div>
                  <FormControl sx={{ m: 1, width: 300 }}>
                    <Select
                      id="demo-simple-select3"
                      value={reason}
                      onChange={handleChange3}
                      inputProps={{ "aria-label": "Without label" }}
                      size="small"
                    >
                      {input3.map((x) => {
                        return (
                          <MenuItem value={x.ReasonCode} key={x.ReasonCode}>
                            {x.ReasonText}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="btnContainerEditTicket">
          <button className="btn_Cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn_Confirm"
            onClick={() => buttonActionSaveResult(group, code, reason)}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveResultModal;
